import { loadScript, removeScripts } from 'common-utils';

import { TrackingTool } from '../tracking-tool';

export class VWO implements TrackingTool {
  private readonly _id: string;

  constructor(id: string) {
    this._id = id;
  }

  async turnOff() {
    removeScripts(['dev.visualwebsiteoptimizer.com']);

    Object.keys(window).forEach((key) => {
      if (key.startsWith('_vwo') || key.startsWith('vwo')) {
        try {
          delete window[key as keyof typeof window];
        } catch (error) {}
      }
    });
  }

  async turnOn() {
    await loadScript(
      `https://dev.visualwebsiteoptimizer.com/lib/${this._id}.js`,
    );
  }

  getName(): string {
    return 'vwo';
  }
}
